export default __webpack_public_path__ + "static/18705-5e1e183e175729da4879c0b22b8dbf31.jpg";